const originalConsoleLog = console.log;
const originalConsoleInfo = console.info;

const shouldSuppressThirdPartyMessage = (value: unknown) => {
  if (typeof value !== 'string') return false;
  return (
    value.includes('i18next is made possible') ||
    value.includes('Download the React DevTools')
  );
};

console.log = (...args) => {
  if (shouldSuppressThirdPartyMessage(args[0])) return;
  originalConsoleLog(...args);
};

console.info = (...args) => {
  if (shouldSuppressThirdPartyMessage(args[0])) return;
  originalConsoleInfo(...args);
};
